export const switcherRedirect = tenant => {
  let host = window.location.host.split('.')
  host[0] = tenant
  return `${window.location.protocol}//${host.join('.')}`
}
